<app-cookie-popin [policyUrl]="pageDetails.policyUrl" [cookiePolicyUrl]="pageDetails.cookiePolicyUrl"
                  [alternateDisplayForMarkets]="alternateDisplayForMarkets"
                  (action)="popinAction($event)" *ngIf="openPopin && pageDetails && isTranslationLoaded"></app-cookie-popin>
<h1 style="text-align: center" *ngIf="loadEnd && !pageDetails" > Error 404 </h1>
<div class="header" *ngIf="!openPopin && pageDetails">
  <i class="fa fa-times text-white" (click)="exit()"></i>
  <div class="text-center text-white">
    {{ 'header' | translate }}
  </div>
</div>
<div class="page page-background" *ngIf="!openPopin && pageDetails">
  <br/>
  <h1 class="text-center"> {{ 'title' | translate }}</h1>
  <div class="text-center"> {{ 'content' | translate }}</div>
  <div class="btn-group spacing-top-4 text-center white-background no-select">
    <div (click)="allReject()">
      <i class="fa fa-times" (click)="allReject()"></i>
      <div class="text">{{ 'btn.reject' | translate }}</div>
    </div>
    <hr class="solid">

    <div (click)="allAccept()">
      <i class="fa fa-check" (click)="allAccept()"></i>
      <div class="text">{{ 'btn.agree' | translate }}</div>
    </div>
  </div>
  <div class="block spacing-top-2 white-background" *ngFor="let cookie of pageDetails.cookiePurposes">
    <div class="block-title">{{ cookie.title | uppercase }}</div>
    <i class="fa fa-check-circle mandatory-icon" *ngIf="cookie.isMandatory"></i>
    <div class="toggle-list" *ngIf="!cookie.isMandatory " (click)="toggle(cookie.key)">
      <!--   neutral -->
      <ng-container *ngIf="getParam(cookie.key) === null">
        <i class="fa fa-toggle-on toggle"></i>
        <i class="fa fa-circle dot"></i>
        <i class="fa fa-circle white-dot"></i>
      </ng-container>
      <!--   on -->
      <ng-container *ngIf="getParam(cookie.key) === true">
        <i class="fa fa-toggle-on toggle-on"></i>
      </ng-container>
      <!--   off -->
      <ng-container *ngIf="getParam(cookie.key) === false">
        <i class="fa fa-toggle-on toggle-off"></i>
      </ng-container>
    </div>
    <div class="mandatory"  *ngIf="cookie.isMandatory"> {{ 'mandatory' | translate }}</div>
    <div class="block-text spacing-top-3" *ngIf="!cookie.open">{{ cookie.shortDescription }}</div>
    <div class="block-text spacing-top-4" *ngIf="cookie.open">{{ cookie.longDescription }}</div>
    <div class="block-text spacing-top-4" *ngIf="cookie.open">
      <h4 *ngIf="cookie.partners && cookie.partners.length">{{ 'partners' | translate }}</h4>
      <div class="spacing-top-1" *ngFor="let partner of cookie.partners">
        <a [href]="partner.url" target="_blank">{{ partner.name}}</a> {{ toTime(pageDetails.validity) }}
      </div>
    </div>
    <div class="seemore spacing-top-3" (click)="cookie.open = true" *ngIf="!cookie.open &&
     ((cookie.shortDescription !== cookie.longDescription) || (cookie.partners && cookie.partners.length))">
      <i class="fa fa-caret-down"></i>
      {{ 'btn.seemore' | translate }}
      <i class="fa fa-caret-down"></i>
    </div>
  </div>
  <div style="height: 100px;"></div>
</div>
<div class="fixed-bottom" *ngIf="!openPopin && pageDetails">
  <p class="text-center spacing-top-2">
    <button class="custom btn btn-xl btn-primary text-white no-select" [disabled]="isSomeUnselected()" (click)="save()" >{{ 'btn.validate' | translate }}</button>
  </p>
</div>

